<div class="stick-top">
  <mat-toolbar><mat-icon>comment</mat-icon> Worklog</mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" (click)="reload()"><mat-icon>refresh</mat-icon> Refresh</button>&nbsp;
    <div class="fill-space"></div>
    <micro-date-range [(unit)]="dateRangeSelector.dateRangeUnit" [(from)]="dateRangeSelector.from" [(fromInfinite)]="dateRangeSelector.fromInfinite" [(until)]="dateRangeSelector.until" [(untilInfinite)]="dateRangeSelector.untilInfinite" ></micro-date-range>
  </div>
</div>

<table class="dataTable">
  <thead>
    <tr>
      <th style="width: 150px;" class="dateTimeHeader">
        Date/Time
      </th>
      <th style="width: 150px;">
        Logged By
        <micro-user-select [(userId)]="filter.userId"></micro-user-select>
      </th>
      <th class="text-left" style="padding: 5px;">
        Feedback<br/>
        <input style="width:200px;" [(ngModel)]="filter.feedback">
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td class="align-top" style="padding: 5px;">{{element.datetime | dateTime}}</td>
      <td class="align-top" style="padding: 5px;"><micro-user-lookup [userId]="element.userId"></micro-user-lookup></td>
      <td class="mono multiline align-top" style="padding: 5px;">{{element.feedback}}</td>

<!--        <div style="margin: 5px 0">-->

<!--        </div>-->
    </tr>
  </tbody>
</table>

<mat-paginator #paginator
               (page)="reload()">
</mat-paginator>
